export const USER_WORKSPACE_ROLE = {
  ADMIN: 'ADMIN',
  FINANCE: 'FINANCE',
  DEVELOPER: 'DEVELOPER',
  READ_ONLY: 'READ_ONLY',
};

export const USER_COMPANY_ROLE = {
  GENERAL_ADMIN: 'GENERAL_ADMINISTRATOR',
  USER: 'USER',
};

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  BLOCKED: 'BLOCKED',
  PENDING: 'PENDING',
  PENDING_INVITATION: 'PENDING_INVITATION',
  PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
};
